<template>
  <ipo3-page>
    <template slot="title">{{$t("titles.source")}}</template>
    <template slot="tools">
      <el-button icon="el-icon-edit" @click="onCreate" type="primary">{{$t("btns.add")}}</el-button>
    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row)"
                  size="mini"
                  type="success"
                >{{$t('btns.edit')}}</el-button>
                 <el-button
                  @click="onDelete(scope.$index, scope.row)"
                  size="mini"
                  type="danger"
                >{{$t('btns.del')}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
      <source-dialog ref="sourceDialog" @sucess="onSucess"></source-dialog>
    </template>
  </ipo3-page>
</template>
<script>
import sourceDialog from './views/source_dialog'
export default {
  name: "news-theme",
  components:{sourceDialog},
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      isLoading: false,

      getRowClass: {
        background: "#F2F2F2"
      },
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "name" },
        { name: "數值", id: "value" },
        { name: "創建時間", id: "create_time" }
      ],
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },
  created() {
    this.getData();
  },
  methods: {
    
    getData(page = 1, size = 10) {
      var self = this;
      this.$http.get("/admin/source", { page: page, size: size }).then(res => {
        console.log("res:", res);
        let { total } = res.data;
        self.pagecount = total;
        self.tableData = res.data.data;
      });
    },
     onDelete(index,value)
    {
      var self = this;
      this.$http.post('/admin/source/delete',{id:value.id}).then(res=>{
          if(res.code==200)
          {
            self.getData();
            self.$message.success("删除成功");
          }else
          {
            self.$message.error(res.msg);
          }
      });
    },
    handleCurrentChange(value) {
      this.currentPage = value;
      this.getData(this.currentPage, this.paginate);
    },
    handleSizeChange(size) {
      this.paginate = size;
      this.getData(this.currentPage, this.paginate);
    },
    onSucess()
    {
      this.getData();
    },
    onCreate() {
      this.$refs.sourceDialog.show();
    },
    onHandle(index,value)
    {
      this.$refs.sourceDialog.show(value);
    }
  }
};
</script>